import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import RequireAuth from '../../components/athletes/RequireAuth';
import SchedulePage from '../schedule/SchedulePage';

// Phase C.5e.1 — SCHEDULE CONSOLIDATION. This file is now a THIN ROUTE
// WRAPPER — it contains NO schedule data-loading or presentation logic
// of its own. It resolves the one route param this route contributes
// (`teamId`) and hands it to the ONE canonical schedule page/controller
// (SchedulePage.js / scheduleController.js), which also backs
// DivisionSchedulePage.js's own route. See scheduleController.js's own
// header for the full history of why this consolidation happened (a
// plain Team Head Coach's "View Full Division" link used to land on a
// separately-evolved, unfixed loader).
export default function TeamSchedulePage() {
  const { teamId } = useParams();
  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Navbar />
      <RequireAuth><SchedulePage teamId={teamId} /></RequireAuth>
    </Box>
  );
}
